import { createApi } from '@reduxjs/toolkit/query/react';
import { restBaseQuery } from '../../api/rest/baseQuery';
import { appConfiguration } from '../../configuration/appConfiguration';

type TagsResponse = {
  items: { id: string; name: string }[];
};

const tagsSlice = createApi({
  reducerPath: 'tagsApi',
  baseQuery: restBaseQuery(appConfiguration.rioTags.api.url),
  endpoints: (build) => ({
    getTags: build.query<TagsResponse, void>({
      query: () => ({ url: '/tags' }),
    }),
  }),
});

export const {
  reducer: tagsReducer,
  reducerPath: tagsReducerPath,
  middleware: tagsMiddleware,
  useGetTagsQuery,
} = tagsSlice;
